/**
 * useSessionAreaId
 *
 * Returns the resolved area ID for the current session (collection + area).
 *
 * Composes `useSessionCollectionName`, `useSessionAreaName`, the areas and
 * collections lists from Redux, and the pure `resolveAreaId` function.
 * No direct Redux session selectors are used.
 *
 * @see src/platform-services/session/resolveAreaId.ts
 */
import { useAppSelector } from '@/store/hooks';
import { areasItemsSelector } from '@/store/selectors/areas';
import { collectionsSelector } from '@/store/selectors/collections';
import { useSessionCollectionName } from './useSessionCollectionName';
import { useSessionAreaName } from './useSessionAreaName';
import { resolveAreaId } from './resolveAreaId';
export const useSessionAreaId = () => {
    const collectionName = useSessionCollectionName();
    const areaName = useSessionAreaName();
    const areas = useAppSelector(areasItemsSelector);
    const collections = useAppSelector(collectionsSelector);
    return resolveAreaId(collectionName, areaName, areas, collections);
};
